;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';

interface VisaCardDarkIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function VisaCardDarkIcon({ size = 24, ...props }: VisaCardDarkIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_8664_25218)">
        <path
          d="M2.62496 0.800049H39.375C40.8241 0.800049 42 1.94527 42 3.35769V27.6437C42 29.0548 40.8241 30.2 39.375 30.2H2.62496C1.17465 30.2002 0 29.0548 0 27.6438V3.35769C0 1.94527 1.17594 0.800049 2.62496 0.800049Z"
          fill="#1434CB"
        />
        <path
          d="M21.3913 13.4552C21.3723 14.8518 22.7238 15.6312 23.7419 16.0946C24.788 16.5701 25.1393 16.8749 25.1353 17.3001C25.1274 17.9508 24.3009 18.238 23.5273 18.2492C22.1778 18.2687 21.3933 17.9089 20.7694 17.6366L20.2833 19.7614C20.9091 20.0308 22.068 20.2657 23.2698 20.276C26.0906 20.276 27.9362 18.9754 27.9461 16.9588C27.9571 14.3997 24.1561 14.2579 24.1821 13.114C24.1911 12.7672 24.5454 12.3971 25.322 12.3029C25.7063 12.2553 26.7673 12.219 27.9701 12.7364L28.4422 10.6807C27.7954 10.4606 26.964 10.2499 25.9289 10.2499C23.2738 10.2499 21.4062 11.5682 21.3913 13.4552ZM32.9788 10.4271C32.4638 10.4271 32.0296 10.7077 31.836 11.1384L27.8064 20.125H30.6252L31.1862 18.6771H34.6308L34.9562 20.125H37.4406L35.2726 10.4271H32.9788ZM33.3731 13.0469L34.1866 16.6885H31.9587L33.3731 13.0469ZM17.9736 10.4271L15.7517 20.125H18.4377L20.6586 10.4271H17.9736ZM13.9999 10.4271L11.2041 17.0278L10.0732 11.4153C9.94041 10.7888 9.41638 10.4271 8.83445 10.4271H4.26389L4.20001 10.7086C5.13828 10.8988 6.20431 11.2056 6.85012 11.5337C7.24539 11.7342 7.35818 11.9095 7.48794 12.3859L9.62998 20.125H12.4687L16.8207 10.4271H13.9999Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_8664_25218">
          <rect y="0.800049" width="42" height="29.4" rx="4" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
